const baseUrl: string = process.env.REACT_APP_API_URL || '';

class LandingPage {
  private uri: string;

  constructor(uri: string) {
    this.uri = uri;
  }

  public read = (params: any) => ({
    baseUrl,
    method: 'get',
    params,
    uri: this.uri,
  });

  public readOne = (id: any) => ({
    baseUrl,
    method: 'get',
    uri: `${this.uri}/${id}`,
  });

  public post = (params: any) => ({
    baseUrl,
    method: 'post',
    params,
    uri: this.uri,
  });

  public put = (params: any, id: string) => ({
    baseUrl,
    method: 'patch',
    params,
    uri: `${this.uri}/${id}`,
  });

  public delete = (id: string) => ({
    baseUrl,
    method: 'delete',
    uri: `${this.uri}/${id}`,
  });

  public updateStatus = (params: any, id: string) => ({
    baseUrl,
    method: 'put',
    params,
    uri: `${this.uri}/status/${id}`,
  });

  public bulkUpdateStatus = (params: any, id: string) => ({
    baseUrl,
    method: 'put',
    params,
    uri: `${this.uri}/status`,
  });
}

export default new LandingPage('/cms/v1/landing-pages');



// WEBPACK FOOTER //
// ./src/libraries/api/landing-page.tsx